<template>
    <v-app-bar
        class="blue accent-3"
        dense
        style="margin-bottom:20px;"
    >
        <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
        </v-btn>

        <template v-slot:extension>
            <v-tabs centered dark optional center-active show-arrows class="py-0 my-0" v-show="$vuetify.breakpoint.mdAndUp">
                <v-tab class="pa-0 my-0">
                    <router-link :to="staffDashboard">
                        <v-btn color="transparent" class="ma-1 white--text" small depressed>Staff Dashboard</v-btn>
                    </router-link>
                </v-tab>
                <v-tab class="pa-0">
                    <v-menu offset-y open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="transparent"
                                v-bind="attrs"
                                v-on="on"
                                class="ma-1"
                                small
                                depressed
                            >
                                Information
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="staff in staffing"
                                :key="staff.title"
                                router :to="{name: staff.route, params: {empID: userID}}"
                            >
                                <v-list-item-title>{{ staff.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-tab>
                <v-tab  class="pa-0">
                    <v-menu offset-y open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="transparent"
                                v-bind="attrs"
                                v-on="on"
                                class="ma-1"
                                small
                                depressed
                            >
                                Certifications
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="cert in certifications"
                                :key="cert.title"
                                router :to="{name: cert.route, params: {empID: userID}}"

                            >
                                <v-list-item-title>{{ cert.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-tab>
                <v-tab class="pa-0">
                    <v-menu offset-y open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="transparent"
                                v-bind="attrs"
                                v-on="on"
                                class="ma-1"
                                small
                                depressed
                            >
                                Vehicles
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="vehicle in vehicles"
                                :key="vehicle.title"
                                router :to="{name: vehicle.route, params: {empID: userID}}"

                            >
                                <v-list-item-title>{{ vehicle.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-tab>
                <v-tab class="pa-0">
                    <v-menu offset-y open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="transparent"
                                v-bind="attrs"
                                v-on="on"
                                class="ma-1"
                                small
                                depressed
                            >
                                Document Library
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="doc in documents"
                                :key="doc.title"
                                router :to="{name: doc.route, params: {empID: userID}}"

                            >
                                <v-list-item-title>{{ doc.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-tab>
                <v-tab class="pa-0" v-if="Role === 'Administration' || Role === 'Human Resources' || Role === 'Human Resources Assistant' || Role === 'SuperAdministrator' || Role === 'Direct Care Staff'">
                    <v-menu offset-y open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="transparent"
                                v-bind="attrs"
                                v-on="on"
                                class="ma-1"
                                small
                                depressed
                            >
                                Compensations/Deductions
                            </v-btn>
                        </template>
                        
                        <v-list>
                            <template v-if="Role !== 'Direct Care Staff'">
                                <v-list-item
                                    v-for="payrollReport in payrollReports"
                                    :key="payrollReport.title"
                                    router :to="{name: payrollReport.route, params: {empID: userID}}"
                                >
                                    <v-list-item-title>{{ payrollReport.title }}</v-list-item-title>
                                </v-list-item>
                            </template>
                            <template v-else>
                                <v-list-item
                                    router :to="{name: 'Reimbursements', params: {empID: userID}}"
                                >
                                    <v-list-item-title>Reimbursements</v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-tab>
            </v-tabs>
        </template>

        <v-spacer class="desktop"></v-spacer>

        <!-- Main Dashboard Button - Always visible
        <router-link
          :to="{
            name: 'Dashboard1'
          }"
        >
          <v-btn
            color="transparent"
            class="ma-1 white--text"
            small
            depressed
            >Main Dashboard</v-btn
          >
        </router-link>

        <v-spacer></v-spacer>
    -->

        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn

                    v-bind="attrs"
                    v-on="on"
                    class="ma-1 mobile"
                    small
                    depressed
                >
                    Staff Menu
                </v-btn>
            </template>

            <!-- <div class="hide-on-mobile"> -->
            <div v-show="$vuetify.breakpoint.smAndDown">
                <v-list>
                    <!-- Main Dashboard - Always visible in mobile menu 
                    <v-list-item
                        router
                        :to="{
                          name: 'Dashboard1'
                        }"
                      >
                        <v-list-item-title>Main Dashboard</v-list-item-title>
                        <v-list-item-icon>
                          <v-icon>mdi-home</v-icon>
                        </v-list-item-icon>
                      </v-list-item>-->

                      <!-- Staff Dashboard - Always visible in mobile menu -->
                      <v-list-item
                        router
                        :to="staffDashboard"
                      >
                        <v-list-item-title>Staff Dashboard</v-list-item-title>
                        <v-list-item-icon>
                          <v-icon>mdi-account</v-icon>
                        </v-list-item-icon>
                      </v-list-item>

                    <v-list-group
                        prepend-icon="mdi-account-circle"
                        @click.stop.prevent
                    >
                        <template v-slot:activator>
                            <v-list-item-title>
                                Information
                            </v-list-item-title>
                        </template>

                        <v-list-item
                            v-for="staff in staffing"
                            :key="staff.title"
                            router :to="{name: staff.route, params: {empID: userID}}"
                        >
                            <v-list-item-title>{{ staff.title }}</v-list-item-title>
                            <v-list-item-icon>
                                <!-- <v-icon v-text="icon"></v-icon> -->
                            </v-list-item-icon>
                        </v-list-item>

                    </v-list-group>

                    <v-list-group
                        prepend-icon="mdi-account-circle"
                        @click.stop.prevent
                    >
                        <template v-slot:activator>
                            <v-list-item-title>Certifications</v-list-item-title>
                        </template>

                        <v-list-item
                            v-for="cert in certifications"
                            :key="cert.title"
                            router :to="{name: cert.route, params: {empID: userID}}"
                        >
                            <v-list-item-title>{{ cert.title }}</v-list-item-title>

                            <v-list-item-icon>
                                <!-- <v-icon v-text="icon"></v-icon> -->
                            </v-list-item-icon>
                        </v-list-item>

                    </v-list-group>

                    <!-- <v-list-group
                        prepend-icon="mdi-account-circle"
                        @click.stop.prevent
                    >
                        <template v-slot:activator>
                        <v-list-item-title>Reimbursements</v-list-item-title>
                        </template>

                        <v-list-item
                        v-for="re in reimbursements"
                        :key="re.title"
                        router :to="{name: re.route, params: {empID: userID}}"
                        >
                        <v-list-item-title>{{ re.title }}</v-list-item-title>

                        <v-list-item-icon>
                            <v-icon v-text="icon"></v-icon>
                        </v-list-item-icon>
                        </v-list-item>

                    </v-list-group> -->

                    <v-list-group
                        prepend-icon="mdi-account-circle"
                        @click.stop.prevent
                    >
                        <template v-slot:activator>
                            <v-list-item-title>Vehicles</v-list-item-title>
                        </template>

                        <v-list-item
                            v-for="vehicle in vehicles"
                            :key="vehicle.title"
                            router :to="{name: vehicle.route, params: {empID: userID}}"
                        >
                            <v-list-item-title>{{ vehicle.title }}</v-list-item-title>

                            <v-list-item-icon>
                                <!-- <v-icon v-text="icon"></v-icon> -->
                            </v-list-item-icon>
                        </v-list-item>

                    </v-list-group>

                    <v-list-group
                        prepend-icon="mdi-account-circle"
                        @click.stop.prevent
                    >
                        <template v-slot:activator>
                        <v-list-item-title>Document Library</v-list-item-title>
                        </template>

                        <v-list-item
                            v-for="doc in documents"
                            :key="doc.title"
                            router :to="{name: doc.route, params: {empID: userID}}"
                        >
                            <v-list-item-title>{{ doc.title }}</v-list-item-title>
                            <v-list-item-icon>
                                <!-- <v-icon v-text="icon"></v-icon> -->
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list-group>

                    <v-list-group
                        prepend-icon="mdi-account-circle"
                        @click.stop.prevent
                        v-if="Role === 'Administration' || Role === 'Human Resources' || Role === 'Human Resources Assistant' || Role === 'SuperAdministrator' || Role === 'Direct Care Staff'"
                    >
                        <template v-slot:activator>
                            <v-list-item-title>Compensations/Deductions</v-list-item-title>
                        </template>

                        <template v-if="Role !== 'Direct Care Staff'">
                            <v-list-item
                                v-for="payrollReport in payrollReports"
                                :key="payrollReport.title"
                                router :to="{name: payrollReport.route, params: {empID: userID}}"
                            >
                                <v-list-item-title>{{ payrollReport.title }}</v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-else>
                            <v-list-item
                                router :to="{name: 'Reimbursements', params: {empID: userID}}"
                            >
                                <v-list-item-title>Reimbursements</v-list-item-title>
                            </v-list-item>
                        </template>

                    </v-list-group>
                </v-list>
            </div>
        </v-menu>

        <v-spacer class="mobile"></v-spacer>

        <v-tooltip v-if="isShowClockInOutNotifBtn === true" bottom color="warning lighten-5" outlined>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class=""
                    fab
                    x-small
                    elevation="1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="clockInOut_NotifBtn = true"
                >
                    <v-badge dot color="red darken-5" overlap v-if="clockInOutBadgeFlag.sum > 0">
                        <v-icon>mdi-clock-alert-outline</v-icon>
                    </v-badge>
                    <v-icon color="secondary" v-if="clockInOutBadgeFlag.sum == 0">mdi-clock-alert-outline</v-icon>
                </v-btn>
            </template>
            <span class="text--secondary">Time Clocked In/Out of staff(s).</span>
        </v-tooltip>
        <v-dialog
            transition="dialog-top-transition"
            v-model="clockInOut_NotifBtn"
            max-width="840"
        >
            <v-snackbar
                top
                v-model="editTimeClockInOutSnackbar"
                :timeout="5000"
            >
                {{ editTimeClockInOutSnackbarText }}
                <template v-slot:action="{ attrs }">
                    <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="editTimeClockInOutSnackbar = false"
                    >
                        Close
                    </v-btn>
                </template>
            </v-snackbar>
            <v-card>
                <v-app-bar
                    color="warning lighten-5"
                >
                    <v-app-bar-nav-icon></v-app-bar-nav-icon>

                    <v-toolbar-title>{{ clockInOutNotifTitle }}</v-toolbar-title>
                </v-app-bar>

                <v-card-text>
                    <v-divider class="mb-3"></v-divider>
                    <v-row>
                        <v-col cols="9" sm="3" md="3">
                            <v-menu
                                ref="clockInOutDateFilterMenu"
                                v-model="clockInOutDateFilterMenu"
                                :close-on-content-click="false"
                                :return-value.sync="clockInOutDateFilter"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="clockInOutDateFilter"
                                        label="Filter by Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                        :disabled="isLoadingClockInOutTable"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="clockInOutDateFilter"
                                    scrollable
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="clockInOutDateFilterMenu = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.clockInOutDateFilterMenu.save(clockInOutDateFilter), getAllTimeSheetsByStateByProgram()"
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-spacer></v-spacer>
                        <!-- <v-col v-if="Role === 'Administration' || Role === 'Super Administrator'" cols="1" sm="1" md="1" class="my-auto d-flex justify-center">
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        class="mx-auto"
                                        v-on="on"
                                        v-bind="attrs"
                                        @click="delPastSched"
                                        :disabled="delPastSched_btn"
                                        :loading="delPastSched_btn"
                                    >
                                        <v-icon color="red lighten-1">mdi-information</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ "Delete Past Schedules with \"No clock In\" status" }}</span>
                                <br/>
                            </v-tooltip>
                        </v-col> -->
                        <v-col v-if="Role === 'Administration' || Role === 'SuperAdministrator'" cols="1" sm="1" md="1" class="my-auto d-flex justify-center">
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        v-on="on"
                                        v-bind="attrs"
                                        @click="loadPastSched"
                                        :disabled="loadPastSched_btn"
                                        :loading="loadPastSched_btn"
                                    >
                                        <v-icon color="primary">mdi-download</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ "Load Past Schedules with \"No clock In\" status" }}</span>
                                <br/>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="1" sm="1" md="1" class="my-auto d-flex justify-center">
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="secondary"
                                        fab
                                        x-small
                                        text
                                        class="my-1"
                                        v-on="on"
                                        v-bind="attrs"
                                        :disabled="isLoadingClockInOutTable"
                                        :loading="isLoadingClockInOutTable"
                                        @click="reloadClockInOutTable"
                                    >
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ "Refresh" }}</span>
                                <br/>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-data-table
                        fixed-header
                        height="280px"
                        width="600"
                        class="mx-auto"
                        :headers="changeClockType ? clockInListHeaders : clockOutListHeaders"
                        :items="clockInOutList"
                        :loading="isLoadingClockInOutTable"
                    >

                        <template
                            v-slot:body="{ items }"
                        >
                            <tbody>
                                <tr
                                    v-for="item in items"
                                    :key="item._id"
                                >
                                    <td>{{ item.Employee.Name }}</td>
                                    <td class="text-center">{{ changeClockType ? item.ClockInSchedule : item.ClockOutSchedule }}</td>
                                    <td class="text-center">
                                        <v-btn
                                            elevation="0"
                                            @click="getStaffShift(item)"
                                            :disabled="isLoadingClockInOutTable"
                                        >
                                            {{
                                                changeClockType ? isClockTypeStatus(item) === "No Clock In" ?  " - - - " : item.ClockIn :
                                                isClockTypeStatus(item) === "No Clock Out" ?  " - - - " : item.ClockOut
                                            }}
                                        </v-btn>
                                    </td>
                                    <td class="text-center">{{ isClockTypeStatus(item) }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions>
                    <v-badge :color="dynamicClockInOutBadgeColor()" overlap
                        :content="dynamicClockInOutBadge()"
                    >
                        <v-btn
                            color="blue darken-1"
                            text
                            elevation="1"
                            @click="changeClockType = !changeClockType"
                        >
                            Clocked {{ changeClockType ? "Out" : "In" }} Times
                        </v-btn>
                    </v-badge>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="clockInOut_NotifBtn = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="selectedClockInOutShiftDialog" width="600px">
            <v-card>
                <v-card-title class="text-h6">
                    Edit
                    <!--{{ selectedShift.Employee?.Name }} time clocked {{ changeClockType ? "in" : "out" }}-->
                </v-card-title>

                <v-divider class="mb-3"></v-divider>
                <v-card-text>
                    <!-- <p class="mb-0">Program: {{ selectedShift.Program?.Name }}</p>-->
                    <!-- <p>Client(s): {{ "Sample" }}</p> -->
                    <v-form
                    >
                        <v-row>
                            <v-col class="d-flex" cols="12" md="6" sm="6" v-if="changeClockType">
                                <v-datetime-picker
                                    v-model="toUpdate_clockIn"
                                    time-format="hh:mm a"
                                    date-format="yyyy-MM-dd"
                                    label="Edit time clocked in"
                                    :error-messages="clockedInErrors"
                                    @change="$v.toUpdate_clockIn.$touch()"
                                    @blur="$v.toUpdate_clockIn.$touch()"
                                    required
                                ></v-datetime-picker>
                            </v-col>
                            <v-col class="d-flex" cols="12" md="6" sm="6" v-else>
                                <v-datetime-picker
                                    v-model="toUpdate_clockOut"
                                    time-format="hh:mm a"
                                    date-format="yyyy-MM-dd"
                                    label="Edit time clocked out"
                                    :error-messages="clockedOutErrors"
                                    @change="$v.toUpdate_clockOut.$touch()"
                                    @blur="$v.toUpdate_clockOut.$touch()"
                                    required
                                ></v-datetime-picker>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="d-flex" cols="12" md="12" sm="6">
                                <v-btn
                                    v-if="Role === 'Administration'"
                                    color="red darken-1"
                                    text
                                    :loading="updateClockInOutDateTime_btn"
                                    :disabled="updateClockInOutDateTime_btn"
                                    @click="delTimeSheetOnReports"
                                >
                                    Delete
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="green darken-1"
                                    text
                                    :loading="updateClockInOutDateTime_btn"
                                    :disabled="updateClockInOutDateTime_btn"
                                    @click="updateClockedInOutDateTime()"
                                >
                                    Update
                                </v-btn>

                                <v-btn
                                    color="secondary"
                                    text
                                    @click="selectedClockInOutShiftDialog = false"
                                >
                                    Close
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app-bar>
</template>
<script>
import axios from "axios";
import moment from "moment";
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import {mapGetters} from "vuex";
import {setUserTz} from "../../utils/timezone";
import DateTimeUtil from "../../utils/date-time.util";

const url = require("../client_config/config").url;

export default {
    props: {
        empId: {
            type: String,
            default: "",
        },
        triggerStaffNavReactiveness: Boolean
    },

    mixins: [validationMixin],

    validations: {
        toUpdate_clockIn: {required},
        toUpdate_clockOut: {required}
    },

    data: () => ({
        Role: localStorage.getItem('userRole'),
        staffing: [
            {title: 'Inservice Training', icon: 'medicine', route: 'InserviceTraining'},
            {title: 'Adjustments', icon: 'medicine', route: 'Adjustments'},
            {title: 'Client Tests', icon: 'medicine', route: 'ClientTest'},
            // { title: 'Performance Reviews', icon: 'rate_review', route: 'Review' }, NOTE: Temporarily Hide this Route
            // {title: 'New Hire Documents', icon: 'medicine', route: 'NewHirePortal'},
            {title: 'Time Off Requests', icon: 'medicine', route: 'TimeOff'},
            {title: 'Emergency Contacts', icon: 'medicine', route: 'EmergencyContact'},
            {title: 'User Notifications', icon: 'medicine', route: 'UserNotifications'},
            {title: 'Inventory', icon: 'medicine', route: 'StaffInventory'},
            // {title: 'Garnishments', icon: 'medicine', route: 'Garnishments'},
            
        ],

        certifications: [
            {title: 'View Certifications', icon: 'medicine', route: 'Certs'},
        ],

        // reimbursements: [
        //     {title: 'Reimbursements', icon: 'medicine', route: 'Reimbursements'},
        // ],

        vehicles: [
            {title: 'Vehicle Inspection', icon: 'medicine', route: 'Vehicle Inspection'},
            {title: 'Vehicle Maintenance', icon: 'medicine', route: 'Vehicle Maintenance'},
        ],

        documents: [
            {title: 'View Library', route: 'DocumentLibrary'},
        ],
        items: [
            {title: 'Position', content: 'Direct Care Staff', icon: 'medicine', route: '/'},
            {title: 'Employment Status:', content: 'Full-Time', icon: 'medicine', route: '/'},
            {title: 'Clients Worked With', content: 'Freddie Mercury, Paula Abdul', icon: 'medicine', route: '/'},
            {title: 'Current Program', content: 'Metz', icon: 'medicine', route: '/'},
        ],
        payrollReports: [
            {title: 'Salary Raise', icon: 'medicine', route: 'Raise'},
            {title: 'Bonus', icon: 'medicine', route: 'Bonus'},
            {title: 'Reimbursements', icon: 'medicine', route: 'Reimbursements'},
            {title: 'Health Care', icon: 'medicine', route: 'Health Care'},
            {title: 'Incentives', icon: 'medicine', route: 'Incentives'},
            {title: 'Garnishments', icon: 'medicine', route: 'Garnishments'},
            {title: 'Workers Comp', icon: 'medicine', route: 'WorkersComp'},
        ],
        staffDashboard: "",

        userState: localStorage.getItem('userState'),
        userPrograms: localStorage.getItem('userPrograms'),
        userProgramsList: [],
        clockInOut_NotifBtn: false,
        isShowClockInOutNotifBtn: false,
        clockInOutList: [],
        changeClockType: true,
        isLoadingClockInOutTable: true,
        clockInOutDateFilterMenu: false,
        clockInOutDateFilter: moment(new Date()).format("YYYY-MM-DD"),
        clockInOutBadgeFlag: {
            in: 0,
            out: 0,
            sum: 0
        },

        selectedClockInOutShiftDialog: false,
        selectedShift: {},
        toUpdate_clockIn: "",
        toUpdate_clockIn_rules: [val => !!val || "time clocked in field is requiered!"],
        toUpdate_clockOut: "",
        toUpdate_clockOut_rules: [val => !!val || "time clocked out field is requiered!"],
        textFieldProps: {
            appendIcon: "event"
        },
        updateClockInOutDateTime_btn: false,

        editTimeClockInOutSnackbar: false,
        editTimeClockInOutSnackbarText: "",
        reactiveTimesheetTable: false,

        clockInListHeaders: [
            {
                text: 'Name',
                align: 'start',
                sortable: true,
                value: 'Employee.Name',
                filterable: false,
            },
            { text: 'Start', align: 'center', value: 'ClockInSchedule' },
            { text: 'Time Clocked In', align: 'center', value: 'ClockIn', filterable: false, },
            { text: 'Status', align: 'center', sortable: false, filterable: false, },
        ],
        clockOutListHeaders: [
            {
                text: 'Name',
                align: 'start',
                sortable: false,
                value: 'Employee.Name',
                filterable: false,
            },
            { text: 'End', align: 'center', value: 'ClockOutSchedule' },
            { text: 'Time Clocked Out', align: 'center', value: 'ClockOut', filterable: false, },
            { text: 'Status', align: 'center', sortable: false, filterable: false, },
        ],

        delPastSched_btn: false,
        loadPastSched_btn: false,
    }),
    computed: {
        userID() {
            // return this.empId === '' ? localStorage.getItem("userID") : this.empId
            return this.empId === '' ? this.$route.params.employeeID : this.empId
        },

        clockInOutNotifTitle () {
            if (this.changeClockType) {
                return "Clock In times of staffs schedule(s)."
            } else {
                return "Clock Out times of staffs schedule(s)."
            }
        },

        clockedInErrors () {
            const errors = []
            if (!this.$v.toUpdate_clockIn.$dirty) return errors
            !this.$v.toUpdate_clockIn.required && errors.push('Time Clocked In is required.')
            return errors
        },

        clockedOutErrors () {
            const errors = []
            if (!this.$v.toUpdate_clockOut.$dirty) return errors
            !this.$v.toUpdate_clockOut.required && errors.push('Time Clocked Out is required.')
            return errors
        },

        ...mapGetters({
              getUserTimezone: "timezones/getUserTimezone",
              getDefaultTz: "timezones/getDefaultTz",
          }),

        userTimezone() {
            const data = {
                userTimezone: this.getUserTimezone,
                defaultTz: this.getDefaultTz,
            };
            return setUserTz(data);
        },
    },

    watch: {
        triggerStaffNavReactiveness (val) {
            val ? this.getAllTimeSheetsByStateByProgram() : val
        },

        selectedClockInOutShiftDialog (val) {
            if (!val) {
                this.selectedShift = {}
                this.toUpdate_clockIn = ""
                this.toUpdate_clockOut = ""
            }
            // !val ? this.selectedShift = {} : this.selectedShift
        },
    },

    async created() {
        if (localStorage.getItem('userRole') === 'Direct Care Staff' ||
            localStorage.getItem('userRole') === 'Shift Lead' ||
            localStorage.getItem('userRole') === 'Assistant Manager' ||
            localStorage.getItem('userRole') === 'House Manager' ||
            localStorage.getItem('userRole') === 'Program Manager'
        ) {
            this.staffing = [
                {title: 'Inservice Training', icon: 'medicine', route: 'InserviceTraining'},
                // { title: 'Adjustments', icon: 'medicine', route: 'Adjustments' },
                // { title: 'Workers Comp', icon: 'medicine', route: 'WorkersComp' },
                {title: 'Client Tests', icon: 'medicine', route: 'ClientTest'},
                // { title: 'Performance Reviews', icon: 'rate_review', route: 'Review' }, NOTE: Temporarily Hide this Route
                // {title: 'New Hire Documents', icon: 'medicine', route: 'NewHirePortal'},
                {title: 'Time Off Requests', icon: 'medicine', route: 'TimeOff'},
                {title: 'Emergency Contacts', icon: 'medicine', route: 'EmergencyContact'},

            ]
        } else if (localStorage.getItem('userRole') === 'Administration') {
            this.staffing = [
                {title: 'Inservice Training', icon: 'medicine', route: 'InserviceTraining'},
                {title: 'Adjustments', icon: 'medicine', route: 'Adjustments'},
                {title: 'Client Tests', icon: 'medicine', route: 'ClientTest'},
                // { title: 'Performance Reviews', icon: 'rate_review', route: 'Review' }, NOTE: Temporarily Hide this Route
                // {title: 'New Hire Documents', icon: 'medicine', route: 'NewHirePortal'},
                {title: 'Time Off Requests', icon: 'medicine', route: 'TimeOff'},
                {title: 'Emergency Contacts', icon: 'medicine', route: 'EmergencyContact'},
                {title: 'User Notifications', icon: 'medicine', route: 'UserNotifications'},
                {title: 'Inventory', icon: 'medicine', route: 'StaffInventory'},
                // {title: 'Garnishments', icon: 'medicine', route: 'Garnishments'},
                
            ]
        }
        this.staffDashboard = "/StaffInfo/" + this.userID;

        this.userProgramsList = this.userPrograms ? JSON.parse(this.userPrograms) : [];

        this.showClockInOutNotifBtn().finally(() => {
            if (this.isShowClockInOutNotifBtn) {
                this.getAllTimeSheetsByStateByProgram();
            }
        });
    },
    methods: {
        // hideNav(navItem, title) {
        //   navItem.splice(navItem.findIndex((item) => item.title === title));
        // },

        async showClockInOutNotifBtn () {
            let roles = [
                'Administration',
                'Shift Lead',
                'Assistant Manager',
                'House Manager',
                'Program Manager',
                'Client Services Manager',
                'Medical Manager',
                'Finance Manager',
                'Compliance Manager',
                'Human Resources',
                'Program Coordinator',
                'Executive Director'
            ];

            roles.includes(this.Role) ? this.isShowClockInOutNotifBtn = true : false
        },

        async getAllTimeSheetsByStateByProgram () {
            this.isLoadingClockInOutTable = true;
            this.clockInOutBadgeFlag.in = 0;
            this.clockInOutBadgeFlag.out = 0;
            this.clockInOutBadgeFlag.sum = 0;

            const params = {
                startDateFilter: DateTimeUtil.toUTCISOString(DateTimeUtil.toStartOfDay(this.clockInOutDateFilter)),
                endDateFilter: DateTimeUtil.toUTCISOString(DateTimeUtil.toEndOfDay(this.clockInOutDateFilter)),
                userProgramsList: this.userProgramsList.filter(program => program).toString(),
                state: this.userState
            };

            await axios.get(`${url}/timeSheets/state`, {params}).then(res => {
                this.clockInOutList = res.data

                this.clockInOutList.map(timeSheet => {

                    timeSheet.ClockInSchedule = DateTimeUtil.toLocalDateTime(timeSheet.ClockInSchedule);
                    timeSheet.ClockOutSchedule = DateTimeUtil.toLocalDateTime(timeSheet.ClockOutSchedule);

                    timeSheet.ClockIn = DateTimeUtil.toLocalDateTime(timeSheet.ClockIn);
                    timeSheet.ClockOut = DateTimeUtil.toLocalDateTime(timeSheet.ClockOut);

                    if (timeSheet.Shift.isRecurringEvent === "No") {
                        if (timeSheet.Shift.isClockIn && timeSheet.Late > 0) {
                            this.clockInOutBadgeFlag.in++
                        } else if (!timeSheet.Shift.isClockIn) {
                            this.clockInOutBadgeFlag.in++
                        }

                        !timeSheet.Shift.isClockOut ? this.clockInOutBadgeFlag.out++ : this.clockInOutBadgeFlag.out;
                    } else if (timeSheet.Shift.isRecurringEvent === "Yes") {
                        let recurringDatesSchedulesIn = timeSheet.Shift.recurringDatesClockIn == undefined ? [] : timeSheet.Shift.recurringDatesClockIn

                        if (!recurringDatesSchedulesIn.some(sched => sched.timeSheetId === timeSheet._id)) {
                            this.clockInOutBadgeFlag.in++
                        }

                        if (recurringDatesSchedulesIn.length > 0) {
                            recurringDatesSchedulesIn.forEach(sched => {
                                if (sched.timeSheetId === timeSheet._id) {
                                    if (sched.isClockIn && timeSheet.Late > 0) {
                                        this.clockInOutBadgeFlag.in++
                                    } else if (!sched.isClockIn || sched.isClockIn == undefined) {
                                        this.clockInOutBadgeFlag.in++
                                    } else if (sched == undefined || sched.RecurringDateSchedule == undefined) {
                                        this.clockInOutBadgeFlag.in++
                                    }
                                }
                            })
                        }

                        let recurringDatesSchedulesOut = timeSheet.Shift.recurringDatesClockOut == undefined ? [] : timeSheet.Shift.recurringDatesClockOut
                        if (recurringDatesSchedulesOut.length > 0) {
                            recurringDatesSchedulesOut.forEach(sched => {
                                if (sched.timeSheetId === timeSheet._id) {
                                    if (!sched.isClockOut || sched.isClockOut == undefined) {
                                        this.clockInOutBadgeFlag.out++
                                    } else if (sched == undefined || sched.RecurringDateSchedule == undefined) {
                                        this.clockInOutBadgeFlag.out++
                                    }
                                }
                            })
                        } else {
                            this.clockInOutBadgeFlag.out++
                        }
                    }
                })

                this.clockInOutBadgeFlag.sum = this.clockInOutBadgeFlag.in + this.clockInOutBadgeFlag.out;
            }).finally(() => {
                this.delPastSched_btn = false;
                this.loadPastSched_btn = false;
                this.isLoadingClockInOutTable = false;
            })
        },

        isClockTypeStatus (item) {
            if (this.changeClockType) {
                if (item.Shift.isRecurringEvent === "No") {
                    if (item.Shift.isClockIn && item.Late == 0) {
                        return "Clock In"
                    } else if (item.Shift.isClockIn && item.Late > 0) {
                        return "Late"
                    } else if (!item.Shift.isClockIn) {
                        return "No Clock In"
                    }
                } else if (item.Shift.isRecurringEvent === "Yes") {
                    let recurringDatesSchedules = item.Shift.recurringDatesClockIn
                    let toReturnValue = ""

                    recurringDatesSchedules.forEach(sched => {
                        if (sched.timeSheetId === item._id) {
                            if (sched.isClockIn && item.Late == 0) {toReturnValue = "Clock In"}
                            else if (sched.isClockIn && item.Late > 0) {toReturnValue = "Late"}
                            else if (!sched.isClockIn || sched.isClockIn === null) {toReturnValue = "No Clock In"}
                        }
                    })

                    let clockIn = recurringDatesSchedules.find(sched => sched.timeSheetId === item._id)
                    clockIn === undefined ? toReturnValue = "No Clock In" : toReturnValue

                    return toReturnValue
                }
            } else {
                if (item.Shift.isRecurringEvent === "No") {
                    return item.Shift.isClockOut ? "Clock Out" : "No Clock Out"
                } else if (item.Shift.isRecurringEvent === "Yes") {
                    let recurringDatesSchedules = item.Shift.recurringDatesClockOut
                    let toReturnValue = ""

                    recurringDatesSchedules.forEach(sched => {
                        if (sched.timeSheetId === item._id) {
                            if (sched.isClockOut) {toReturnValue = "Clock Out"}
                            else if (!sched.isClockOut || sched.isClockOut === null) {toReturnValue = "No Clock Out"}
                        }
                    })

                    let clockOut = recurringDatesSchedules.find(sched => sched.timeSheetId === item._id)
                    clockOut === undefined ? toReturnValue = "No Clock Out" : toReturnValue

                    return toReturnValue
                }
            }
        },

        dynamicClockInOutBadge () {
            return this.changeClockType ? this.clockInOutBadgeFlag.out : this.clockInOutBadgeFlag.in
        },
        dynamicClockInOutBadgeColor () {
            if (this.changeClockType && this.clockInOutBadgeFlag.out != 0) {
                return "red darken-5"
            } else if (!this.changeClockType && this.clockInOutBadgeFlag.in != 0) {
                return "red darken-5"
            } else {
                return ""
            }
        },

        // get the selected staff's shift info
        getStaffShift (shift) {
            // console.log(shift);
            // console.log(shift._id);
            // console.log(shift.Shift._id);
            // console.log(shift.Shift.isClockIn);
            this.selectedClockInOutShiftDialog = true;
            this.selectedShift = shift;

            if (this.selectedShift.Shift.isRecurringEvent === "No") {
                this.toUpdate_clockIn = this.selectedShift.Shift.isClockIn ? this.selectedShift.ClockIn : undefined
                this.toUpdate_clockOut = this.selectedShift.Shift.isClockOut ? this.selectedShift.ClockOut : undefined
            } else if (this.selectedShift.Shift.isRecurringEvent === "Yes") {
                let recurringDatesSchedulesIn = this.selectedShift.Shift.recurringDatesClockIn
                let recurringDatesSchedulesOut = this.selectedShift.Shift.recurringDatesClockOut

                recurringDatesSchedulesIn.forEach(sched => {
                    if (sched.timeSheetId === this.selectedShift._id) {
                        this.toUpdate_clockIn = sched.isClockIn ? this.selectedShift.ClockIn : undefined
                    }
                })
                let clockIn = recurringDatesSchedulesIn.find(sched => sched.timeSheetId === this.selectedShift._id)
                this.toUpdate_clockIn = (clockIn !== undefined) ? this.selectedShift.ClockIn : undefined

                recurringDatesSchedulesOut.forEach(sched => {
                    if (sched.timeSheetId === this.selectedShift._id) {
                        this.toUpdate_clockOut = sched.isClockOut ? this.selectedShift.ClockOut : undefined
                    }
                })
                let clockOut = recurringDatesSchedulesOut.find(sched => sched.timeSheetId === this.selectedShift._id)
                this.toUpdate_clockOut = (clockOut !== undefined) ? this.selectedShift.ClockOut : undefined
            }
        },

        async updateClockedInOutDateTime () {
            this.$v.$touch()

            this.delPastSched_btn = true;
            this.loadPastSched_btn = true;
            this.updateClockInOutDateTime_btn = true

            let req_body = {}

            if (this.toUpdate_clockIn != this.selectedShift.ClockIn && this.toUpdate_clockIn != undefined && this.toUpdate_clockIn != "") {
                req_body.ClockIn = this.toUpdate_clockIn
            } else {
                req_body.ClockIn = undefined
            }

            if (this.toUpdate_clockOut != this.selectedShift.ClockOut && this.toUpdate_clockOut != undefined && this.toUpdate_clockOut != "") {
                req_body.ClockOut = this.toUpdate_clockOut
            } else {
                req_body.ClockOut = undefined
            }

            req_body.ClockInSchedule = this.selectedShift.ClockInSchedule;

            if (this.changeClockType) {
                if (req_body.ClockIn != undefined) {
                    let getHours = moment.duration(moment(new Date(req_body.ClockIn)).diff(moment(new Date(req_body.ClockInSchedule)))).asHours()

                    if (getHours < 0) {
                        this.editTimeClockInOutSnackbar = true;
                        this.editTimeClockInOutSnackbarText = `Edited Clock in input should not less than clock in schedule.`

                        this.delPastSched_btn = false;
                        this.loadPastSched_btn = false;
                        this.updateClockInOutDateTime_btn = false;
                    } else {
                        this.updateClockInOut(req_body)
                    }
                } else {
                    this.editTimeClockInOutSnackbar = true;
                    this.editTimeClockInOutSnackbarText = `Please input edited clock in.`

                    this.delPastSched_btn = false;
                    this.loadPastSched_btn = false;
                    this.updateClockInOutDateTime_btn = false;
                }
            } else {
                // Check the inputed clock out if less than clocked in.
                if (req_body.ClockOut != undefined) {
                    if (this.selectedShift.ClockIn) {
                        let getHours = moment.duration(moment(new Date(req_body.ClockOut)).diff(moment(new Date(this.selectedShift.ClockIn)))).asHours()

                        if (getHours < 0) {
                            this.editTimeClockInOutSnackbar = true;
                            this.editTimeClockInOutSnackbarText = `Edited Clock out input should not less than clock in.`

                            this.delPastSched_btn = false;
                            this.loadPastSched_btn = false;
                            this.updateClockInOutDateTime_btn = false;
                        } else {
                            this.updateClockInOut(req_body)
                        }
                    } else {
                        this.editTimeClockInOutSnackbar = true;
                        this.editTimeClockInOutSnackbarText = `No clock in yet.`

                        this.delPastSched_btn = false;
                        this.loadPastSched_btn = false;
                        this.updateClockInOutDateTime_btn = false;
                    }
                } else {
                    this.editTimeClockInOutSnackbar = true;
                    this.editTimeClockInOutSnackbarText = `Please input edited clock out.`

                    this.delPastSched_btn = false;
                    this.loadPastSched_btn = false;
                    this.updateClockInOutDateTime_btn = false;
                }
            }
        },

        async updateClockInOut (req_body) {
            await axios.put(`${url}/timeSheets/${this.selectedShift._id}`, req_body).then(async () => {
                this.reactiveTimesheetTable = true
                let clockType = this.changeClockType ? "Clocked In" : "Clocked Out";
                this.editTimeClockInOutSnackbar = true;
                this.editTimeClockInOutSnackbarText = `Time ${clockType} has been successfully edited.`
                this.selectedClockInOutShiftDialog = false;
                this.$emit("triggerStaffInfoTimesheetTableReactiveness", this.reactiveTimesheetTable);
                await this.getAllTimeSheetsByStateByProgram();
            }).catch(error => {
                this.editTimeClockInOutSnackbar = true;
                this.editTimeClockInOutSnackbarText = "Something went wrong please try to reload the page and edit again."
                console.log(error.response.data.msg);
            }).finally(() => {
                this.updateClockInOutDateTime_btn = false;
                setTimeout(() => {
                    this.reactiveTimesheetTable = false
                }, 3000)
            })
        },

        async reloadClockInOutTable () {
            this.clockInOutDateFilter = '';

            this.delPastSched_btn = true;
            this.loadPastSched_btn = true;
            this.isLoadingClockInOutTable = true;

            await this.getAllTimeSheetsByStateByProgram();
        },

        // delete all past schedules with no clock in
        async delPastSched () {
            this.clockInOutDateFilter = '';

            this.delPastSched_btn = true;
            this.loadPastSched_btn = true;
            this.isLoadingClockInOutTable = true;

            await axios.delete(`${url}/timeSheets/schedules/past-schedules`).then(res => {
                console.log(res.data);
            }).finally(async () => {
                await this.getAllTimeSheetsByStateByProgram()
            })
        },

        // delete a time sheet on clock in/out reports.
        async delTimeSheetOnReports () {
            this.updateClockInOutDateTime_btn = true
            const timesheetID = this.selectedShift._id;

            const response = confirm(
                "Are you sure you want to delete this time sheet entry?"
            );

            if (response == true) {
                if (timesheetID != null) {
                    await axios.delete(`${url}/timeSheets/${timesheetID}`).then(() => {
                        this.editTimeClockInOutSnackbar = true;
                        this.editTimeClockInOutSnackbarText = `Time sheet has been deleted successfully.`

                        this.reactiveTimesheetTable = true
                        this.$emit("triggerStaffInfoTimesheetTableReactiveness", this.reactiveTimesheetTable);
                    }).catch(err => {
                        console.log(err.response.data.msg);
                    }).finally(async () => {
                        await this.getAllTimeSheetsByStateByProgram().finally(() => {
                            this.updateClockInOutDateTime_btn = false
                            this.selectedClockInOutShiftDialog = false;
                            setTimeout(() => {
                                this.reactiveTimesheetTable = false
                            }, 3000)
                        });
                    })
                }
            } else {
                this.updateClockInOutDateTime_btn = false
            }
        },

        // add all past schedules to timesheet if isClockIn == false
        async loadPastSched () {
            this.clockInOutDateFilter = '';

            this.delPastSched_btn = true;
            this.loadPastSched_btn = true;
            this.isLoadingClockInOutTable = true;

            await axios.post(`${url}/timeSheets/schedules/add-timesheet-past-schedules`).finally(async () => {
                await this.getAllTimeSheetsByStateByProgram()
            });
        }
    }
}
</script>
<style>
@media only screen and (max-width: 600px) {
  .mobile {
    display: block;
  }

  .hide-on-mobile {
    display: none;
  }

}

/* On screens larger than 600px, ensure elements with the .desktop class remain hidden */
@media only screen and (min-width: 601px) {
  .desktop {
    display: none;
  }
}
</style>
